import batterieCharger from '@/assets/images/locations/RM_Charger/charger.png';
import guidonCharger from '@/assets/images/locations/RM_Charger/charger_guidon.png';
import porteBagageCharger from '@/assets/images/locations/RM_Charger/charger_porte_bagage.png';
import roueCharger from '@/assets/images/locations/RM_Charger/charger_roue.png';
import selleCharger from '@/assets/images/locations/RM_Charger/charger_selle.png';
import batterieNevo from '@/assets/images/locations/RM_Nevo/batterieRieseAndMuller.png';
import phareNevo from '@/assets/images/locations/RM_Nevo/eclairageRieseAndMuller.png';
import guidonNevo from '@/assets/images/locations/RM_Nevo/guidonRieseAndMuller.png';
import cadreAsphalte from '@/assets/images/locations/asphalte/cadre.png';
import chaineAsphalte from '@/assets/images/locations/asphalte/chaine.png';
import roueAsphalte from '@/assets/images/locations/asphalte/roue.png';
import cadreAdris from '@/assets/images/locations/aventure/cadre.png';
import chaineAdris from '@/assets/images/locations/aventure/chaine.png';
import frontAdris from '@/assets/images/locations/aventure/front.png';
import childCadre from '@/assets/images/locations/enfant/cadre.png';
import childChaine from '@/assets/images/locations/enfant/chaine.png';
import childFull from '@/assets/images/locations/enfant/full.png';
import galianMotor from '@/assets/images/locations/galian/motor.png';
import galianPneus from '@/assets/images/locations/galian/pneus.png';
import cadreVadrouille from '@/assets/images/locations/vadrouille/cadre_vadrouille.png';
import chaineVadrouille from '@/assets/images/locations/vadrouille/chaine.png';
import roueVadrouille from '@/assets/images/locations/vadrouille/roue.png';
import vdvPneu from '@/assets/images/locations/velo-de-ville/delta_cruiser_plus.png';
import bellecourBatterie from '@/assets/images/locations/voltaire/Bellecour_Creme_seat.png';
import bellecourMotor from '@/assets/images/locations/voltaire/Engine_Bellecour.png';
import A200Voyage from '@/assets/images/velos/a200_voyage.png';
import vdv from '@/assets/images/velos/a200_voyage.webp';
import type { StaticImageData } from 'next/image';

export type BikePresentation = {
  title: {
    main: string;
    yellow: string;
    other?: string;
  };
  text: string;
  image: StaticImageData;
};

export const NevoPresentation = [
  {
    title: {
      main: 'Sport rime avec ',
      yellow: 'confort',
    },
    text: 'content',
    image: batterieNevo,
  },
  {
    title: {
      main: 'Écrans élégants et ',
      yellow: 'intelligents',
    },
    text: 'content2',
    image: guidonNevo,
  },
  {
    title: {
      main: 'Voir et être ',
      yellow: 'vu',
    },
    text: 'content3',
    image: phareNevo,
  },
] as const;

export const ChargerPresentation = [
  {
    title: {
      main: 'Puissance ',
      yellow: 'embarquée',
    },
    text: 'content',
    image: batterieCharger,
  },
  {
    title: {
      main: 'Centrale de commande ',
      yellow: 'intelligente',
    },
    text: 'content2',
    image: guidonCharger,
  },
  {
    title: {
      main: 'Transforme les chemins de terre en routes ',
      yellow: 'fraîchement goudronnées',
    },
    text: 'content3',
    image: selleCharger,
  },
  {
    title: {
      main: 'Des déplacements ',
      yellow: 'sûrs',
      other: ' à tout moment',
    },
    text: 'content4',
    image: roueCharger,
  },
  {
    title: {
      main: 'Des possibilités presque ',
      yellow: 'infinies',
    },
    text: 'content5',
    image: porteBagageCharger,
  },
] as const;

export const VeloDeVilePresentation = [
  {
    title: {
      main: 'Un confort à toute ',
      yellow: 'épreuve',
    },
    text: 'content',
    image: vdv,
  },
  {
    title: {
      main: 'Des déplacements ',
      yellow: 'sûrs',
      other: '',
    },
    text: 'content2',
    image: vdvPneu,
  },
] as const;

export const A200Presentation = [
  {
    title: {
      main: 'Un voyage sans ',
      yellow: 'limites',
    },
    text: 'content',
    image: A200Voyage,
  },
  {
    title: {
      main: 'Un voyage en toute ',
      yellow: 'sérénité',
    },
    text: 'content2',
    image: vdvPneu,
  },
] as const;

export const BellecourtPresentation = [
  {
    title: {
      main: 'Assistance ',
      yellow: 'Réactive et Efficace',
    },
    text: 'content',
    image: bellecourMotor,
  },
  {
    title: {
      main: 'Pratique et ',
      yellow: 'confortable',
    },
    text: 'content2',
    image: bellecourBatterie,
  },
] as const;

export const GalianPresentation = [
  {
    title: {
      main: 'Motorisation ',
      yellow: 'Surpuissante',
    },
    text: 'content',
    image: galianMotor,
  },
  {
    title: {
      main: 'Fourche acier + ',
      yellow: 'pneus ballons',
    },
    text: 'content2',
    image: galianPneus,
  },
] as const;

export const VadrouillePresentation = [
  {
    title: {
      main: 'Votre partenaire',
      yellow: 'rêvé',
    },
    text: 'content',
    image: cadreVadrouille,
  },
  {
    title: {
      main: 'L’harmonie idéale entre',
      yellow: 'maniabilité et solidité',
    },
    text: 'content2',
    image: roueVadrouille,
  },
  {
    title: {
      main: 'UNE TECHNOLOGIE',
      yellow: 'DE POINTE',
    },
    text: 'content3',
    image: chaineVadrouille,
  },
] as const;

export const AsphaltePresentation = [
  {
    title: {
      main: 'Quand l’aluminium',
      yellow: 'repousse les limites',
    },
    text: 'content',
    image: cadreAsphalte,
  },
  {
    title: {
      main: 'Des roues d’exception pour des performances',
      yellow: 'au sommet',
    },
    text: 'content2',
    image: roueAsphalte,
  },
  {
    title: {
      main: 'UNE TECHNOLOGIE',
      yellow: 'DE POINTE',
    },
    text: 'content3',
    image: chaineAsphalte,
  },
] as const;

export const AdventureAdrisPresentation = [
  {
    title: {
      main: 'Pensé pour la',
      yellow: 'polyvalence',
    },
    text: 'content',
    image: cadreAdris,
  },
  {
    title: {
      main: 'Prêt à affronter',
      yellow: 'tous les chemins',
    },
    text: 'content2',
    image: frontAdris,
  },
  {
    title: {
      main: 'UNE TECHNOLOGIE',
      yellow: 'DE POINTE',
    },
    text: 'content3',
    image: chaineAdris,
  },
] as const;

export const ChildBikePresentation = [
  {
    title: {
      main: 'Pensé pour la',
      yellow: 'découverte',
    },
    text: 'content',
    image: childCadre,
  },
  {
    title: {
      main: 'Prêt à explorer ',
      yellow: 'tous les terrains',
    },
    text: 'content2',
    image: childFull,
  },
  {
    title: {
      main: 'Des équipements pensés pour les',
      yellow: 'jeunes cyclistes',
    },
    text: 'content3',
    image: childChaine,
  },
] as const;
